import bnc          from "bnc";


const block = new bnc('ui-table');


export {block};
